import { useNavigate, useParams } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import config from '../../config';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import chatService from '../../services/chat.service';
import { ProfileExample } from '../../components/profile/ProfileExample';
import { apiMatch } from '../../api/apiMatch.api.js';
import { checkLimitError } from '../../components/limits/utils/checkLimitError.js';
import { LimitModal } from '../../components/limits/LimitModal.jsx';

function NotificationSuperLikeProfile() {
  const params = useParams();
  const hasValidProfileId = Boolean(params.id && params.id !== 'undefined');

  const [userData, setUserData] = useState();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const [limitsKey, setLimitsKey] = useState(null);

  const fetchUserProfile = async () => {
    if (!hasValidProfileId) {
      toast.error('Профиль пользователя больше недоступен');
      navigate(config.ROUTES.NOTIFICATIONS, { replace: true });
      return;
    }

    try {
      const response = await axiosPrivate.get(`${config.API.USERS.BASE}/${params.id}`);
      setUserData(response.data);
    } catch (error) {
      const status = error?.response?.status;

      if (status === 400 || status === 404) {
        toast.error('Профиль пользователя больше недоступен');
        navigate(config.ROUTES.NOTIFICATIONS, { replace: true });
        return;
      }

      console.error('Error fetching user profile:', error);
    }
  };

  const handleToFindOrCreateChat = async () => {
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, userData._id);
      navigate(`/chats/${res.data._id}`);
    } catch (error) {
      const message = error?.response?.data?.message;
      console.error('[Profile] getChatToUserId:', error);
      toast.error(message || 'Ошибка при попытке открыть чат с пользователем');
    }
  };

  const handleLikeOrDisLikeUser = async ({ like = true }) => {
    try {
      await apiMatch.fetchLikeOrDisLike(axiosPrivate, { targetUserId: userData._id, like});
      if (like) {
        await handleToFindOrCreateChat();
      } else {
        await apiMatch.fetchDeletedNotification(axiosPrivate, { notificationId: params.notificationId });
        navigate(config.ROUTES.NOTIFICATIONS);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      const status = error?.response?.status;
      const code = error?.response?.data?.code;

      const limitKey = checkLimitError(message);

      if (status === 429 && limitKey) {
        setLimitsKey(limitKey);
      }

      if (status === 409 && code === 'ALREADY_LIKED') {
        await handleToFindOrCreateChat();
      }

      toast.error(message);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, [params.id]);

  if (!hasValidProfileId) {
    return null;
  }

  return (
    <>
      {limitsKey && <LimitModal domain="swipe" limitsKey={limitsKey} setLimitsKey={setLimitsKey} />}
      <ProfileExample userId={params.id} />
      <div className="fixed z-10 bottom-[31px] left-4 right-4 flex items-center justify-between gap-4">
        <button
          onClick={() => handleLikeOrDisLikeUser({ like: false })}
          className="p-[18.5px] rounded-full border-[#CE5D49] border-2 bg-[#022424] w-full flex items-center justify-center gap-1.5"
        >
          <img src="/icons/remove-red.svg" alt="remove" className="size-[16px]" />
          <p className="text-lg font-medium text-white">Дизлайк</p>
        </button>
        <button
          onClick={() => handleLikeOrDisLikeUser({ like: true })}
          className="p-[18.5px] rounded-full bg-[#A1F69E] w-full flex items-center justify-center gap-1.5"
        >
          <img src="/icons/like-black.svg" alt="heart" className="size-[16px]" />
          <p className="text-lg font-medium text-black">Лайк</p>
        </button>
      </div>
    </>
  );
}

export default NotificationSuperLikeProfile;
